import React, { useState } from "react";

const UIUX = () => {
  const [expandedSections, setExpandedSections] = useState({});

  const toggleSection = (section) => {
    setExpandedSections((prev) => ({
      ...prev,
      [section]: !prev[section],
    }));
  };

  const syllabusData = {
    courseOverview: {
      title: "Course Overview",
      content: (
        <>
          <p className="font-bold text-sm">Objective:</p> Learn the principles
          and practices of UI/UX design to create user-centered digital
          products.
          <p className="font-bold text-sm">Duration:</p> 30 days, 1 hour per
          day.
          <p className="font-bold text-sm">Prerequisites:</p> Basic familiarity
          with design concepts, interest in user experience, and access to a
          computer with design tools.
          <p className="font-bold text-sm">Tools Needed:</p> Figma, Adobe XD,
          Sketch, or similar design software, and a note-taking app or paper for
          sketching.
        </>
      ),
    },
    dailySchedule: {
      title: "Daily Schedule",
      days: [
        {
          day: "Day 1: Introduction to UI/UX",
          objective: "Understand the basics of UI/UX design.",
          topics: (
            <>
              <p className="font-bold text-sm">
                Topics Covered (30 min theory, 30 min practical):
              </p>
              <ul className="list-disc pl-4 text-xs">
                <li>What is UI/UX? Importance in product design.</li>
                <li>Difference between UI and UX.</li>
                <li>Overview of the design process.</li>
              </ul>
              <p className="font-bold text-sm">Hands-On:</p>
              <ul className="list-disc pl-4 text-xs">
                <li>Install Figma and explore its interface.</li>
              </ul>
            </>
          ),
        },
        {
          day: "Day 2: Design Thinking Basics",
          objective: "Learn the design thinking methodology.",
          topics: (
            <>
              <p className="font-bold text-sm">
                Topics Covered (30 min theory, 30 min practical):
              </p>
              <ul className="list-disc pl-4 text-xs">
                <li>
                  Stages of design thinking: Empathize, Define, Ideate,
                  Prototype, Test.
                </li>
                <li>Applying empathy in design.</li>
                <li>Problem-solving with a user-centric approach.</li>
              </ul>
              <p className="font-bold text-sm">Hands-On:</p>
              <ul className="list-disc pl-4 text-xs">
                <li>Identify a user problem and brainstorm solutions.</li>
              </ul>
            </>
          ),
        },
        {
          day: "Day 3: User Research Fundamentals",
          objective: "Understand user research techniques.",
          topics: (
            <>
              <p className="font-bold text-sm">
                Topics Covered (30 min theory, 30 min practical):
              </p>
              <ul className="list-disc pl-4 text-xs">
                <li>Importance of user research.</li>
                <li>Methods: Interviews, surveys, and observation.</li>
                <li>Creating user personas.</li>
              </ul>
              <p className="font-bold text-sm">Hands-On:</p>
              <ul className="list-disc pl-4 text-xs">
                <li>Develop a user persona based on a scenario.</li>
              </ul>
            </>
          ),
        },
        {
          day: "Day 4: User Journey Mapping",
          objective: "Create user journey maps.",
          topics: (
            <>
              <p className="font-bold text-sm">
                Topics Covered (30 min theory, 30 min practical):
              </p>
              <ul className="list-disc pl-4 text-xs">
                <li>What is a user journey map?</li>
                <li>Mapping touchpoints and emotions.</li>
                <li>Identifying pain points and opportunities.</li>
              </ul>
              <p className="font-bold text-sm">Hands-On:</p>
              <ul className="list-disc pl-4 text-xs">
                <li>Sketch a user journey map for a sample app.</li>
              </ul>
            </>
          ),
        },
        {
          day: "Day 5: Information Architecture",
          objective: "Learn to structure content effectively.",
          topics: (
            <>
              <p className="font-bold text-sm">
                Topics Covered (30 min theory, 30 min practical):
              </p>
              <ul className="list-disc pl-4 text-xs">
                <li>Introduction to information architecture (IA).</li>
                <li>Creating sitemaps and hierarchies.</li>
                <li>Card sorting techniques.</li>
              </ul>
              <p className="font-bold text-sm">Hands-On:</p>
              <ul className="list-disc pl-4 text-xs">
                <li>Design a sitemap for a website or app.</li>
              </ul>
            </>
          ),
        },
        {
          day: "Day 6: Wireframing Basics",
          objective: "Understand and create wireframes.",
          topics: (
            <>
              <p className="font-bold text-sm">
                Topics Covered (30 min theory, 30 min practical):
              </p>
              <ul className="list-disc pl-4 text-xs">
                <li>What are wireframes? Low-fidelity vs. high-fidelity.</li>
                <li>Tools for wireframing (Figma, Sketch).</li>
                <li>Basic layout principles.</li>
              </ul>
              <p className="font-bold text-sm">Hands-On:</p>
              <ul className="list-disc pl-4 text-xs">
                <li>Create a low-fidelity wireframe in Figma.</li>
              </ul>
            </>
          ),
        },
        {
          day: "Day 7: Advanced Wireframing",
          objective: "Enhance wireframing skills.",
          topics: (
            <>
              <p className="font-bold text-sm">
                Topics Covered (30 min theory, 30 min practical):
              </p>
              <ul className="list-disc pl-4 text-xs">
                <li>Adding interactivity to wireframes.</li>
                <li>Collaborating with teams on wireframes.</li>
                <li>Iterating based on feedback.</li>
              </ul>
              <p className="font-bold text-sm">Hands-On:</p>
              <ul className="list-disc pl-4 text-xs">
                <li>Refine a wireframe with interactive elements.</li>
              </ul>
            </>
          ),
        },
        {
          day: "Day 8: Introduction to Prototyping",
          objective: "Learn to create interactive prototypes.",
          topics: (
            <>
              <p className="font-bold text-sm">
                Topics Covered (30 min theory, 30 min practical):
              </p>
              <ul className="list-disc pl-4 text-xs">
                <li>What is a prototype? Low-fidelity vs. high-fidelity.</li>
                <li>Tools for prototyping (Figma, Adobe XD).</li>
                <li>Linking screens and transitions.</li>
              </ul>
              <p className="font-bold text-sm">Hands-On:</p>
              <ul className="list-disc pl-4 text-xs">
                <li>Build a simple prototype in Figma.</li>
              </ul>
            </>
          ),
        },
        {
          day: "Day 9: Advanced Prototyping",
          objective: "Master advanced prototyping techniques.",
          topics: (
            <>
              <p className="font-bold text-sm">
                Topics Covered (30 min theory, 30 min practical):
              </p>
              <ul className="list-disc pl-4 text-xs">
                <li>Adding animations and micro-interactions.</li>
                <li>Testing prototype usability.</li>
                <li>Exporting prototypes for feedback.</li>
              </ul>
              <p className="font-bold text-sm">Hands-On:</p>
              <ul className="list-disc pl-4 text-xs">
                <li>Add animations to a prototype.</li>
              </ul>
            </>
          ),
        },
        {
          day: "Day 10: UI Design Principles",
          objective: "Understand UI design fundamentals.",
          topics: (
            <>
              <p className="font-bold text-sm">
                Topics Covered (30 min theory, 30 min practical):
              </p>
              <ul className="list-disc pl-4 text-xs">
                <li>Color theory and typography.</li>
                <li>Layout and grid systems.</li>
                <li>Consistency and accessibility in UI.</li>
              </ul>
              <p className="font-bold text-sm">Hands-On:</p>
              <ul className="list-disc pl-4 text-xs">
                <li>Design a color scheme and typography set.</li>
              </ul>
            </>
          ),
        },
        {
          day: "Day 11: Creating a Design System",
          objective: "Build a reusable design system.",
          topics: (
            <>
              <p className="font-bold text-sm">
                Topics Covered (30 min theory, 30 min practical):
              </p>
              <ul className="list-disc pl-4 text-xs">
                <li>What is a design system?</li>
                <li>Components, tokens, and guidelines.</li>
                <li>Maintaining consistency across products.</li>
              </ul>
              <p className="font-bold text-sm">Hands-On:</p>
              <ul className="list-disc pl-4 text-xs">
                <li>Create a basic design system in Figma.</li>
              </ul>
            </>
          ),
        },
        {
          day: "Day 12: Visual Design in UI",
          objective: "Apply visual design to UI.",
          topics: (
            <>
              <p className="font-bold text-sm">
                Topics Covered (30 min theory, 30 min practical):
              </p>
              <ul className="list-disc pl-4 text-xs">
                <li>Using icons, images, and illustrations.</li>
                <li>Applying shadows and gradients.</li>
                <li>Creating high-fidelity mockups.</li>
              </ul>
              <p className="font-bold text-sm">Hands-On:</p>
              <ul className="list-disc pl-4 text-xs">
                <li>Design a high-fidelity mockup based on a wireframe.</li>
              </ul>
            </>
          ),
        },
        {
          day: "Day 13: Usability Testing Basics",
          objective: "Learn to conduct usability tests.",
          topics: (
            <>
              <p className="font-bold text-sm">
                Topics Covered (30 min theory, 30 min practical):
              </p>
              <ul className="list-disc pl-4 text-xs">
                <li>What is usability testing?</li>
                <li>Planning a test session.</li>
                <li>Recruiting participants and creating tasks.</li>
              </ul>
              <p className="font-bold text-sm">Hands-On:</p>
              <ul className="list-disc pl-4 text-xs">
                <li>Plan a usability test for a prototype.</li>
              </ul>
            </>
          ),
        },
        {
          day: "Day 14: Conducting Usability Tests",
          objective: "Execute and analyze usability tests.",
          topics: (
            <>
              <p className="font-bold text-sm">
                Topics Covered (30 min theory, 30 min practical):
              </p>
              <ul className="list-disc pl-4 text-xs">
                <li>Running a usability test session.</li>
                <li>Observing and recording feedback.</li>
                <li>Analyzing results and identifying issues.</li>
              </ul>
              <p className="font-bold text-sm">Hands-On:</p>
              <ul className="list-disc pl-4 text-xs">
                <li>Conduct a mock usability test with peers.</li>
              </ul>
            </>
          ),
        },
        {
          day: "Day 15: Heuristic Evaluation",
          objective: "Perform heuristic evaluations.",
          topics: (
            <>
              <p className="font-bold text-sm">
                Topics Covered (30 min theory, 30 min practical):
              </p>
              <ul className="list-disc pl-4 text-xs">
                <li>What are heuristics? Nielsen’s 10 heuristics.</li>
                <li>Evaluating designs against heuristics.</li>
                <li>Documenting findings.</li>
              </ul>
              <p className="font-bold text-sm">Hands-On:</p>
              <ul className="list-disc pl-4 text-xs">
                <li>Evaluate a prototype using heuristics.</li>
              </ul>
            </>
          ),
        },
        {
          day: "Day 16: Accessibility in Design",
          objective: "Design for accessibility.",
          topics: (
            <>
              <p className="font-bold text-sm">
                Topics Covered (30 min theory, 30 min practical):
              </p>
              <ul className="list-disc pl-4 text-xs">
                <li>Importance of accessibility (a11y).</li>
                <li>WCAG guidelines and best practices.</li>
                <li>Designing for screen readers and color blindness.</li>
              </ul>
              <p className="font-bold text-sm">Hands-On:</p>
              <ul className="list-disc pl-4 text-xs">
                <li>Modify a design for accessibility.</li>
              </ul>
            </>
          ),
        },
        {
          day: "Day 17: Interaction Design",
          objective: "Learn interaction design principles.",
          topics: (
            <>
              <p className="font-bold text-sm">
                Topics Covered (30 min theory, 30 min practical):
              </p>
              <ul className="list-disc pl-4 text-xs">
                <li>What is interaction design?</li>
                <li>Designing intuitive interactions.</li>
                <li>Feedback mechanisms (e.g., hovers, clicks).</li>
              </ul>
              <p className="font-bold text-sm">Hands-On:</p>
              <ul className="list-disc pl-4 text-xs">
                <li>Design an interactive button in a prototype.</li>
              </ul>
            </>
          ),
        },
        {
          day: "Day 18: Microinteractions",
          objective: "Add microinteractions to enhance UX.",
          topics: (
            <>
              <p className="font-bold text-sm">
                Topics Covered (30 min theory, 30 min practical):
              </p>
              <ul className="list-disc pl-4 text-xs">
                <li>What are microinteractions?</li>
                <li>Designing for notifications and transitions.</li>
                <li>Improving user engagement.</li>
              </ul>
              <p className="font-bold text-sm">Hands-On:</p>
              <ul className="list-disc pl-4 text-xs">
                <li>Add a microinteraction to a prototype.</li>
              </ul>
            </>
          ),
        },
        {
          day: "Day 19: Responsive Design",
          objective: "Design for multiple devices.",
          topics: (
            <>
              <p className="font-bold text-sm">
                Topics Covered (30 min theory, 30 min practical):
              </p>
              <ul className="list-disc pl-4 text-xs">
                <li>Responsive design principles.</li>
                <li>Adapting layouts for mobile, tablet, and desktop.</li>
                <li>Using breakpoints and constraints.</li>
              </ul>
              <p className="font-bold text-sm">Hands-On:</p>
              <ul className="list-disc pl-4 text-xs">
                <li>Create a responsive wireframe for multiple devices.</li>
              </ul>
            </>
          ),
        },
        {
          day: "Day 20: Collaboration with Developers",
          objective: "Learn to collaborate with developers.",
          topics: (
            <>
              <p className="font-bold text-sm">
                Topics Covered (30 min theory, 30 min practical):
              </p>
              <ul className="list-disc pl-4 text-xs">
                <li>Handing off designs to developers.</li>
                <li>Using design specs and assets.</li>
                <li>Communicating design decisions.</li>
              </ul>
              <p className="font-bold text-sm">Hands-On:</p>
              <ul className="list-disc pl-4 text-xs">
                <li>Export design assets and specs from Figma.</li>
              </ul>
            </>
          ),
        },
        {
          day: "Day 21: Introduction to Motion Design",
          objective: "Explore motion design in UI/UX.",
          topics: (
            <>
              <p className="font-bold text-sm">
                Topics Covered (30 min theory, 30 min practical):
              </p>
              <ul className="list-disc pl-4 text-xs">
                <li>Role of motion in UX.</li>
                <li>Basic animation principles.</li>
                <li>
                  Tools for motion design (e.g., Principle, After Effects).
                </li>
              </ul>
              <p className="font-bold text-sm">Hands-On:</p>
              <ul className="list-disc pl-4 text-xs">
                <li>Create a simple motion prototype.</li>
              </ul>
            </>
          ),
        },
        {
          day: "Day 22: User Feedback and Iteration",
          objective: "Incorporate user feedback into designs.",
          topics: (
            <>
              <p className="font-bold text-sm">
                Topics Covered (30 min theory, 30 min practical):
              </p>
              <ul className="list-disc pl-4 text-xs">
                <li>Collecting and analyzing feedback.</li>
                <li>Iterating on designs based on insights.</li>
                <li>Documenting design changes.</li>
              </ul>
              <p className="font-bold text-sm">Hands-On:</p>
              <ul className="list-disc pl-4 text-xs">
                <li>Iterate a prototype based on feedback.</li>
              </ul>
            </>
          ),
        },
        {
          day: "Day 23: Final Project – Planning",
          objective: "Plan the final UI/UX project.",
          topics: (
            <>
              <p className="font-bold text-sm">
                Topics Covered (30 min theory, 30 min discussion):
              </p>
              <ul className="list-disc pl-4 text-xs">
                <li>Overview of the final project.</li>
                <li>Suggested project ideas (e.g., mobile app, website).</li>
                <li>Defining goals and target users.</li>
              </ul>
              <p className="font-bold text-sm">Hands-On:</p>
              <ul className="list-disc pl-4 text-xs">
                <li>Create a project brief and user persona.</li>
              </ul>
            </>
          ),
        },
        {
          day: "Day 24: Final Project – Research and Journey Mapping",
          objective: "Conduct research and map user journeys.",
          topics: (
            <>
              <p className="font-bold text-sm">
                Topics Covered (30 min theory, 30 min practical):
              </p>
              <ul className="list-disc pl-4 text-xs">
                <li>Performing user research for the project.</li>
                <li>Creating a user journey map.</li>
                <li>Identifying key features.</li>
              </ul>
              <p className="font-bold text-sm">Hands-On:</p>
              <ul className="list-disc pl-4 text-xs">
                <li>Develop a user journey map for the project.</li>
              </ul>
            </>
          ),
        },
        {
          day: "Day 25: Final Project – Wireframing",
          objective: "Create wireframes for the project.",
          topics: (
            <>
              <p className="font-bold text-sm">
                Topics Covered (30 min theory, 30 min practical):
              </p>
              <ul className="list-disc pl-4 text-xs">
                <li>Designing low-fidelity wireframes.</li>
                <li>Iterating based on research insights.</li>
                <li>Ensuring usability in wireframes.</li>
              </ul>
              <p className="font-bold text-sm">Hands-On:</p>
              <ul className="list-disc pl-4 text-xs">
                <li>Build wireframes for the project in Figma.</li>
              </ul>
            </>
          ),
        },
        {
          day: "Day 26: Final Project – Prototyping",
          objective: "Develop an interactive prototype.",
          topics: (
            <>
              <p className="font-bold text-sm">
                Topics Covered (30 min theory, 30 min practical):
              </p>
              <ul className="list-disc pl-4 text-xs">
                <li>Converting wireframes to prototypes.</li>
                <li>Adding interactions and transitions.</li>
                <li>Testing prototype flow.</li>
              </ul>
              <p className="font-bold text-sm">Hands-On:</p>
              <ul className="list-disc pl-4 text-xs">
                <li>Create a prototype for the project.</li>
              </ul>
            </>
          ),
        },
        {
          day: "Day 27: Final Project – Visual Design",
          objective: "Apply visual design to the project.",
          topics: (
            <>
              <p className="font-bold text-sm">
                Topics Covered (30 min theory, 30 min practical):
              </p>
              <ul className="list-disc pl-4 text-xs">
                <li>Designing high-fidelity mockups.</li>
                <li>Using the design system created earlier.</li>
                <li>Ensuring accessibility and responsiveness.</li>
              </ul>
              <p className="font-bold text-sm">Hands-On:</p>
              <ul className="list-disc pl-4 text-xs">
                <li>Design a high-fidelity mockup in Figma.</li>
              </ul>
            </>
          ),
        },
        {
          day: "Day 28: Final Project – Usability Testing",
          objective: "Conduct usability testing on the project.",
          topics: (
            <>
              <p className="font-bold text-sm">
                Topics Covered (30 min theory, 30 min practical):
              </p>
              <ul className="list-disc pl-4 text-xs">
                <li>Planning and executing a usability test.</li>
                <li>Collecting and analyzing feedback.</li>
                <li>Documenting test results.</li>
              </ul>
              <p className="font-bold text-sm">Hands-On:</p>
              <ul className="list-disc pl-4 text-xs">
                <li>Run a usability test on the prototype.</li>
              </ul>
            </>
          ),
        },
        {
          day: "Day 29: Final Project – Iteration and Polish",
          objective: "Refine the project based on feedback.",
          topics: (
            <>
              <p className="font-bold text-sm">
                Topics Covered (30 min theory, 30 min practical):
              </p>
              <ul className="list-disc pl-4 text-xs">
                <li>Iterating on design based on test results.</li>
                <li>Adding final touches (e.g., microinteractions).</li>
                <li>Preparing a design handoff document.</li>
              </ul>
              <p className="font-bold text-sm">Hands-On:</p>
              <ul className="list-disc pl-4 text-xs">
                <li>Refine and polish the project design.</li>
              </ul>
            </>
          ),
        },
        {
          day: "Day 30: Final Project – Presentation",
          objective: "Present the final UI/UX project.",
          topics: (
            <>
              <p className="font-bold text-sm">
                Topics Covered (30 min theory, 30 min practical):
              </p>
              <ul className="list-disc pl-4 text-xs">
                <li>Preparing a presentation or demo.</li>
                <li>Discussing design process and decisions.</li>
                <li>Presenting to peers or stakeholders.</li>
              </ul>
              <p className="font-bold text-sm">Hands-On:</p>
              <ul className="list-disc pl-4 text-xs">
                <li>Present the completed project.</li>
              </ul>
            </>
          ),
        },
      ],
    },
    learningOutcomes: {
      title: "Learning Outcomes",
      content: (
        <>
          <p className="text-sm">
            By the end of this course, learners will be able to:
          </p>
          <ul className="list-disc pl-4 text-xs">
            <li>Conduct user research and create user personas.</li>
            <li>Design wireframes, prototypes, and high-fidelity mockups.</li>
            <li>Perform usability testing and iterate on designs.</li>
            <li>Complete a UI/UX project from concept to presentation.</li>
          </ul>
        </>
      ),
    },
    finalProjectIdeas: {
      title: "Suggested Final Project Ideas",
      content: (
        <>
          <ul className="list-disc pl-4 text-xs">
            <li>
              <span className="font-bold text-sm">Mobile App:</span> Design a
              to-do or fitness app interface.
            </li>
            <li>
              <span className="font-bold text-sm">Website:</span> Create a
              portfolio or e-commerce website design.
            </li>
            <li>
              <span className="font-bold text-sm">Dashboard:</span> Design a
              data visualization dashboard for a business.
            </li>
          </ul>
        </>
      ),
    },
    additionalNotes: {
      title: "Additional Notes",
      content: (
        <>
          <ul className="list-disc pl-4 text-xs">
            <li>Encourage practice with real-world design challenges.</li>
            <li>Provide resources (e.g., Figma tutorials, UI/UX articles).</li>
            <li>Use discussion time for feedback and brainstorming.</li>
          </ul>
          <p className="text-sm">
            This syllabus progresses from UI/UX fundamentals to a complete
            design project over 30 days.
          </p>
        </>
      ),
    },
  };

  // Function to handle enrollment (replace with actual enrollment logic)
  const handleEnroll = () => {
    alert("Enroll Now clicked! (Add your enrollment logic here)");
  };

  return (
    <div className="min-h-screen bg-gray-100 font-sans">
      {/* Hero Section */}
      <header className="bg-gradient-to-r from-red-300 to-indigo-600 py-8 text-center">
        <h1 className="text-2xl font-bold mb-1 text-white">UI/UX Syllabus</h1>
        <p className="text-sm text-white">
          Master UI/UX Design (30 Hours – 1 Hour Per Day)
        </p>
      </header>

      {/* Training Availability Banner */}
      <div className="fixed top-34 left-80v right-4 bg-yellow-200 border border-yellow-400 rounded-lg p-3 text-center shadow-md z-10">
        <h2 className="text-sm font-semibold text-indigo-800">
          Training Available
        </h2>
        <p className="text-xs text-gray-700">Online Class | Physical Class</p>
        <button
          onClick={handleEnroll}
          className="mt-2 px-4 py-1 bg-orange-600 text-white text-xs rounded-lg hover:bg-orange-700 transition duration-300"
        >
          Enroll Now
        </button>
      </div>

      <div className="max-w-4xl mx-auto p-2 pt-16 pb-16">
        {/* Course Overview */}
        <div className="mb-2 border border-gray-200 rounded-lg">
          <h2
            onClick={() => toggleSection("courseOverview")}
            className="bg-gray-100 p-1 cursor-pointer flex justify-between items-center text-sm font-semibold text-gray-700 hover:bg-gray-200"
          >
            {syllabusData.courseOverview.title}
            <span>{expandedSections["courseOverview"] ? "▲" : "▼"}</span>
          </h2>
          {expandedSections["courseOverview"] && (
            <div className="p-1 bg-white text-gray-600 leading-tight">
              {syllabusData.courseOverview.content}
            </div>
          )}
        </div>

        {/* Daily Schedule */}
        <div className="mb-2 border border-gray-200 rounded-lg">
          <h2
            onClick={() => toggleSection("dailySchedule")}
            className="bg-gray-100 p-1 cursor-pointer flex justify-between items-center text-sm font-semibold text-gray-700 hover:bg-gray-200"
          >
            {syllabusData.dailySchedule.title}
            <span>{expandedSections["dailySchedule"] ? "▲" : "▼"}</span>
          </h2>
          {expandedSections["dailySchedule"] && (
            <div className="p-1 bg-white">
              {syllabusData.dailySchedule.days.map((day, index) => (
                <div
                  key={index}
                  className="mb-1 border border-gray-100 rounded-lg"
                >
                  <h3
                    onClick={() => toggleSection(`day${index}`)}
                    className="bg-gray-50 p-1 cursor-pointer flex justify-between items-center text-xs font-medium text-gray-600 hover:bg-gray-100"
                  >
                    {day.day}
                    <span>{expandedSections[`day${index}`] ? "▲" : "▼"}</span>
                  </h3>
                  {expandedSections[`day${index}`] && (
                    <div className="p-1 bg-white text-gray-600 leading-tight">
                      <p className="font-bold text-sm">Objective:</p>{" "}
                      {day.objective}
                      {day.topics}
                    </div>
                  )}
                </div>
              ))}
            </div>
          )}
        </div>

        {/* Learning Outcomes */}
        <div className="mb-2 border border-gray-200 rounded-lg">
          <h2
            onClick={() => toggleSection("learningOutcomes")}
            className="bg-gray-100 p-1 cursor-pointer flex justify-between items-center text-sm font-semibold text-gray-700 hover:bg-gray-200"
          >
            {syllabusData.learningOutcomes.title}
            <span>{expandedSections["learningOutcomes"] ? "▲" : "▼"}</span>
          </h2>
          {expandedSections["learningOutcomes"] && (
            <div className="p-1 bg-white text-gray-600 leading-tight">
              {syllabusData.learningOutcomes.content}
            </div>
          )}
        </div>

        {/* Final Project Ideas */}
        <div className="mb-2 border border-gray-200 rounded-lg">
          <h2
            onClick={() => toggleSection("finalProjectIdeas")}
            className="bg-gray-100 p-1 cursor-pointer flex justify-between items-center text-sm font-semibold text-gray-700 hover:bg-gray-200"
          >
            {syllabusData.finalProjectIdeas.title}
            <span>{expandedSections["finalProjectIdeas"] ? "▲" : "▼"}</span>
          </h2>
          {expandedSections["finalProjectIdeas"] && (
            <div className="p-1 bg-white text-gray-600 leading-tight">
              {syllabusData.finalProjectIdeas.content}
            </div>
          )}
        </div>

        {/* Additional Notes */}
        <div className="mb-2 border border-gray-200 rounded-lg">
          <h2
            onClick={() => toggleSection("additionalNotes")}
            className="bg-gray-100 p-1 cursor-pointer flex justify-between items-center text-sm font-semibold text-gray-700 hover:bg-gray-200"
          >
            {syllabusData.additionalNotes.title}
            <span>{expandedSections["additionalNotes"] ? "▲" : "▼"}</span>
          </h2>
          {expandedSections["additionalNotes"] && (
            <div className="p-1 bg-white text-gray-600 leading-tight">
              {syllabusData.additionalNotes.content}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default UIUX;
